import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import useCreateDiscount from '@/features/dashboard/discounts/hooks/useCreateDiscount.ts';
import {
  discountSchema,
  DiscountFormData,
  DiscountInputData,
  discountDefaultValues,
} from '@/features/dashboard/discounts/schemas/discountSchema.ts';
import { discountMapper } from '@/features/dashboard/discounts/types/discountMapper.ts';
import DiscountForm from '@/features/dashboard/discounts/components/DiscountForm.tsx';

const CreateDiscountModal = ({ onClose }: { onClose: () => void }) => {
  const createMutation = useCreateDiscount();

  const methods = useForm<DiscountInputData>({
    resolver: zodResolver(discountSchema),
    defaultValues: discountDefaultValues,
  });

  const { handleSubmit } = methods;

  const onSubmit = (data: DiscountFormData) => {
    const dto = discountMapper.toCreateDto(data);
    createMutation.mutate(dto, { onSuccess: () => onClose() });
  };

  return (
    <Modal onClose={onClose} isDirty={methods.formState.isDirty}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader title="Dodaj kod promocyjny" onClose={onClose} />
          <ModalContent>
            <DiscountForm />
          </ModalContent>
          <ModalFooter>
            <ActionButton
              tone="ghost"
              size="sm"
              type="button"
              onClick={onClose}
            >
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={createMutation.isPending}
            >
              Dodaj kod
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default CreateDiscountModal;
